var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-close.205136cb.png","uri@2x": __webpack_public_path__ + "icon-close.4a5c1a93.png","uri@3x": __webpack_public_path__ + "icon-close.79899b7d.png",
    width: 30,
    height: 30
});